export default function Django_Create_Project() {
  return <div>Django_Create_Project Component</div>;
}
